import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m12 21-2.575.725a.7.7 0 0 1-.638-.113.67.67 0 0 1-.287-.562q0-.3.075-.488a.7.7 0 0 1 .2-.287L10.5 19v-5.5l-7.275 2.15a.96.96 0 0 1-.85-.15Q2 15.225 2 14.725q0-.375.125-.625a.85.85 0 0 1 .35-.375L10.5 9V3.5q0-.625.438-1.063A1.45 1.45 0 0 1 12 2q.624 0 1.063.438.437.437.437 1.062V9l8.025 4.725a.85.85 0 0 1 .35.375q.125.25.125.625 0 .5-.375.775a.96.96 0 0 1-.85.15L13.5 13.5V19l1.725 1.275a.7.7 0 0 1 .2.288q.075.187.075.487a.67.67 0 0 1-.287.563.7.7 0 0 1-.638.112z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }